import { createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "store";
import { User, UserPreferences } from "Types/User";
import {
  getCurrentUserData,
  getCurrentUserPreferences,
  updateUserPreferences,
} from "Network/Core/DashboardModule/auth";
import { setLanguage } from "./dashboardReducer";

interface InitialStateType {
  isLoading: boolean;
  userData: User | null;
  userPreferences: UserPreferences | null;
  isSuperAdmin: boolean;
  error?: any;
}

const initialState: InitialStateType = {
  isLoading: false,
  userData: null,
  userPreferences: null,
  isSuperAdmin: false,
  error: null,
};

// Define the slice with initial state and reducers for whole platform
const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    onLoading(state, action) {
      state.isLoading = action?.payload;
    },
    onInitialize(state, action) {
      state.userData = action?.payload.userData;
      state.userPreferences = action?.payload.userPreferences;
      state.isLoading = false;
    },
    onPreferencesUpdate(state, action) {
      state.userPreferences = action?.payload;
      state.isLoading = false;
    },
    onError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

export const initializeAuthAction = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(slice.actions.onLoading(true));
    const { data: userData } = await getCurrentUserData();
        
    const hasAdminAccess = userData?.isGlobalAdminUser || userData?.isAdmin || userData?.flag1 || userData?.flag2;
    
    if (!hasAdminAccess) {
      dispatch(slice.actions.onError({ message: "Unauthorized access" }));
      localStorage.clear();
      window.location.href = "/";
      return;
    }
    
    const { data: userPreferences } = await getCurrentUserPreferences();
    dispatch(slice.actions.onInitialize({ userData, userPreferences }));
  } catch (err) {
    dispatch(slice.actions.onError(err));
  }
};

export const updateUserPreferencesAction =
  (body: any) => async (dispatch: AppDispatch) => {
    dispatch(slice.actions.onLoading(true));
    const response = await updateUserPreferences(body);
    if (response?.status === 200) {
      const { data: userPreferences } = await getCurrentUserPreferences();
      dispatch(slice.actions.onPreferencesUpdate(userPreferences));
      dispatch(setLanguage(userPreferences.language.code));
    } else {
      dispatch(slice.actions.onError(response));
    }
  };
